import React from 'react';
import { motion } from 'framer-motion';
import { STEPS, useFunnel } from '../../contexts/FunnelContext';
export function ProgressBar() {
  const {
    step,
    t,
    goTo
  } = useFunnel();
  const pct = (step + 1) / STEPS.length * 100;
  return <nav aria-label="Progress" className="border-b border-ink-200 bg-white" data-id="element-557" data-mp="2t4axzbr4vep3">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-558" data-mp="2x534hx8mf5ho">
        <ol className="hidden gap-1 py-3 md:flex" data-id="element-559" data-mp="3ktmdyg3epobc">
          {STEPS.map((k, i) => <li key={k} className="flex-1" data-id="element-560" data-mp="3krt996ccte5z" data-mpi={i}>
              <button type="button" disabled={i > step} onClick={() => goTo(i)} aria-current={i === step ? 'step' : undefined} className={`w-full whitespace-nowrap text-left text-xs font-semibold transition-[color] duration-150 ease-out ${i === step ? 'text-ink' : i < step ? 'text-ink-500 hover:text-ink' : 'text-ink-300'}`} data-id="element-561" data-mp="3prnyl5ghdvox">
                {t(k)}
              </button>
            </li>)}
        </ol>
        <div className="flex items-center justify-between py-2.5 text-xs font-semibold md:hidden" data-id="element-562" data-mp="ouq74q5ocqk">
          <span className="text-ink" data-id="element-563" data-mp="3rv5y9ktl2dre">{t(STEPS[step])}</span>
          <span className="tabular-nums text-ink-500" data-id="element-564" data-mp="alzb7189m25s">
            {step + 1}/{STEPS.length}
          </span>
        </div>
      </div>
      <div className="h-1 bg-ink-100" data-id="element-565" data-mp="5nxuuo284gy0">
        <motion.div className="h-1 bg-lime" initial={false} animate={{
        width: `${pct}%`
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-566" data-mp="jl4ai9rnhzj0" />
      </div>
    </nav>;
}